const optionsComponent = require('../optionsComponent/optionsComponent');

const toggleLink = Object.assign({}, optionsComponent, {
    subelements: {
        trigger: null,
        ok: null,
        ko: null,
        validationMessage: null
    },
    okValue: null,
    koValue: null,

    init: function () {
        optionsComponent.init.call(this);

        this.subelements.trigger.onclick = () => { this.doToggle(); return false; };
    },

    doToggle: function () {
        if (this.getValue() == this.okValue) {
            this.setValue(this.koValue);
        } else {
            this.setValue(this.okValue);
        }

        if (this.getValue() == this.okValue) {
            this.hm.helper.hideElement(this.subelements.ko);
            this.hm.helper.showElement(this.subelements.ok);
        } else {
            this.hm.helper.hideElement(this.subelements.ok);
            this.hm.helper.showElement(this.subelements.ko);
        }
        this.filterDependables();
    }
});

module.exports = toggleLink;